import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'

import ModalConfirmHightlight from 'components/NavV2/Modals/ModalConfirmHightlight/ModalConfirmHightlight'
import ModalConfirmSendActivity from 'components/NavV2/Modals/ModalConfirmSendActivity/ModalConfirmSendActivity'
import ModalCreateLink from 'components/NavV2/Modals/ModalCreateOrUpdateLink/ModalCreateOrUpdateLink'
import ModalInfoUser from 'components/NavV2/Modals/ModalInfoUser/ModalInfoUser'
import UnsavedChangesModal from 'components/NavV2/Modals/UnsavedChangesModal/UnsavedChangesModal'
import ModalConfirmDeleteLink from 'components/NavV2/Modals/ModalConfirmDeleteLink/ModalConfirmDeleteLink'

export const MODAL_TYPES = {
  MODAL_CONFIRM_DELETE_LINK: 'MODAL_CONFIRM_DELETE_LINK',
  MODAL_CONFIRM_HIGHTLIGHT: 'MODAL_CONFIRM_HIGHTLIGHT',
  MODAL_CONFIRM_SEND_ACTIVITY: 'MODAL_CONFIRM_SEND_ACTIVITY',
  MODAL_CREATE_LINK: 'MODAL_CREATE_LINK',
  MODAL_INFO_USER: 'MODAL_INFO_USER',
  MODAL_SECTION_EVALUATION_CRITERIA: 'MODAL_SECTION_EVALUATION_CRITERIA',
  MODAL_UNSAVED_CHANGES_ACTIVITY: 'MODAL_UNSAVED_CHANGES_ACTIVITY',
}

const MODAL_COMPONENTS = {
  [MODAL_TYPES.MODAL_CONFIRM_HIGHTLIGHT]: ModalConfirmHightlight,
  [MODAL_TYPES.MODAL_CONFIRM_DELETE_LINK]: ModalConfirmDeleteLink,
  [MODAL_TYPES.MODAL_CONFIRM_SEND_ACTIVITY]: ModalConfirmSendActivity,
  [MODAL_TYPES.MODAL_CREATE_LINK]: ModalCreateLink,
  [MODAL_TYPES.MODAL_INFO_USER]: ModalInfoUser,
  [MODAL_TYPES.MODAL_UNSAVED_CHANGES_ACTIVITY]: UnsavedChangesModal,
}

const initalState = {
  hideModal: () => {},
  showModal: () => {},
  store: {},
}

const GlobalModalContext = createContext(initalState)
export const useGlobalModalContext = () => useContext(GlobalModalContext)

export const GlobalModalProvider = ({ children }) => {
  const [store, setStore] = useState()
  const { modalType, modalProps } = store || {}
  const history = useHistory()

  const showModal = useCallback(
    (modalType, modalProps = {}) => {
      setStore((store) => {
        return { ...store, modalProps, modalType }
      })
    },
    [setStore]
  )

  const hideModal = useCallback(() => {
    setStore((store) => {
      return { ...store, modalProps: {}, modalType: null }
    })
  }, [setStore])

  useEffect(() => {
    if (!modalType) {
      return
    }

    const unlisten = history.listen(() => {
      hideModal()
    })

    return unlisten
  }, [history, modalType, hideModal])

  const renderComponent = () => {
    const ModalComponent = MODAL_COMPONENTS[modalType]
    if (!modalType || !ModalComponent) {
      return null
    }
    return <ModalComponent id='global-modal' {...modalProps} />
  }

  const contextValue = useMemo(
    () => ({ hideModal, showModal, store }),
    [hideModal, showModal, store]
  )

  return (
    <GlobalModalContext.Provider value={contextValue}>
      {renderComponent()}
      {children}
    </GlobalModalContext.Provider>
  )
}
